<template>
  <v-container>
    <h2>Inserisci la tua email/username</h2>
    <v-col cols="6">
      <v-text-field
        ref="input"
        label="Email / Username"
        name="emailUsername"
        type="text"
        v-model="userData.Username"
        filled
      ></v-text-field>
    </v-col>
  </v-container>
</template>

<script>
export default {
  props: ["userData"],
  data: () => ({
    error: null,
  }),
  methods: {
    handleSubmit: (e) => {},
  },
};
</script>
